import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import Tour from './Tour';
import Exp from './Exp';
import Visas from './Visas';
import Cruie from './Cruie';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Blog from './Blog';
import WOW from 'wowjs';
import 'animate.css';
import { Helmet } from "react-helmet-async";

function Home () {
 const [packages, setPackages] = useState([]);
 const [destination, setDestination] = useState([]);
 const [homeData, setHomeData] = useState({});
 const [homeBanner, setHomeDataBanner] = useState([]);
 const [tourGuide, settourGuide] = useState([]);
 const [testimonial, settestimonial] = useState([]);
 const [adverteseBanner, setadverteseBanner] = useState([]);
 const [activeTab, setActiveTab] = useState(0);
 const [Pramotionpackeg, setPramotionpackeg] = useState([]);
 const [popularactivities, setpopularactivities] = useState([]);
 const [popularvisa, setpopularvisa] = useState([]);
 const [popularblogs, setpopularblogs] = useState([]);
 const [data, setData] = useState(null);
const [loading, setLoading] = useState(true);



const metaTitle =
  homeData?.meta_title && homeData.meta_title !== "null"
    ? homeData.meta_title
    : "Plan Journeys | Travel & Tour Packages";

const metaDescription =
  homeData?.meta_description && homeData.meta_description !== "null"
    ? homeData.meta_description
    : "";

    const metakeyword =
  homeData?.meta_keyword && homeData.meta_keyword !== "null"
    ? homeData.meta_keyword
    : "";
const BannerMedia = ({ video, image, alt }) => {
  const [videoError, setVideoError] = React.useState(false);

  if (video && !videoError) {
    return (
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        src={video}
        onError={() => setVideoError(true)}
      />
    );
  }

  return <img src={image} alt={alt}   fetchPriority={'high'}
  loading={'eager'} />;
};


  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "inr");

  useEffect(() => {
    const updateCurrency = () => {
      setCurrency(localStorage.getItem("currency") || "inr");
    };

    window.addEventListener("currency-change", updateCurrency);
    return () => window.removeEventListener("currency-change", updateCurrency);
  }, []);

  const getPrice = (item) => {
    if (!item) return "";

    if (currency === "usd") return `$ ${item.price_usd}`;
    if (currency === "aed") return `AED ${item.price_aed}`;
    return `₹ ${item.price_inr}`;
  };
useEffect(() => {
  const cached = sessionStorage.getItem("home_all_data");

  if (cached) {
    const data = JSON.parse(cached);
    setadverteseBanner(data.advertise || []);
    settestimonial(data.testimonial || []);
    setPramotionpackeg(data.posters || []);
    settourGuide(data.guides || []);
    setDestination(data.destinations || []);
    setPackages(data.packages || []);
    setHomeData(data.home || {});
    setHomeDataBanner(data.banner || {});
    setpopularactivities(data.activities || []);
    setpopularvisa(data.visa || {});
    setpopularblogs(data.blogs || {});
    setLoading(false);
    return;
  }

  setLoading(true);

  Promise.all([
    fetch("https://planjourneysglobal.com/admin/api/advertiesBanner").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/testimonial").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/posters").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/tourguide").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/top_destionations").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/popular_Packages").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/home_page").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/home_page/banners/home").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/popular_activities").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/popular_visa").then(r => r.json()),
    fetch("https://planjourneysglobal.com/admin/api/popular_blogs").then(r => r.json()),
  ])
    .then(([
      advertise,
      testimonial,
      posters,
      guides,
      destinations,
      packages,
      home,
      banner,
      activities,
      visa,
      blogs,
    ]) => {
      const payload = {
        advertise: advertise.data,
        testimonial: testimonial.data,
        posters: posters.data,
        guides: guides.data,
        destinations: destinations.data,
        packages: packages.data,
        home: home.data,
        banner: banner.data,
        activities: activities.data,
        visa: visa.data,
        blogs: blogs.data,
      };

      sessionStorage.setItem("home_all_data", JSON.stringify(payload));

      setadverteseBanner(payload.advertise || []);
      settestimonial(payload.testimonial || []);
      setPramotionpackeg(payload.posters || []);
      settourGuide(payload.guides || []);
      setDestination(payload.destinations || []);
      setPackages(payload.packages || []);
      setHomeData(payload.home || {});
      setHomeDataBanner(payload.banner || {});
      setpopularactivities(payload.activities || []);
      setpopularvisa(payload.visa || {});
      setpopularblogs(payload.blogs || {});
    })
    .catch(console.error)
    .finally(() => setLoading(false));
}, []);


useEffect(() => {
  const wow = new WOW.WOW({
    live: false,
    offset: 0,
    mobile: true,
  });
  wow.init();
}, []);
  const showStatic = loading || homeBanner.length === 0;

  const hasDynamicTestimonial =
  homeData?.testimonial_section &&
  homeData.testimonial_section
    .replace(/<[^>]*>/g, "")   // remove HTML tags
    .replace(/&nbsp;/g, "")   // remove nbsp
    .trim().length > 0;

const hasPosterHeading =
  homeData?.poster_heading_editor &&
  homeData.poster_heading_editor
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim().length > 0;

    return(
     <>


<Helmet>
  <title>{metaTitle}</title>

  {/* Description */}
  {metaDescription && (
    <meta name="description" content={metaDescription} />
  )}

  {/* Keywords */}
  {metakeyword && (
    <meta name="keywords" content={metakeyword} />
  )}

  {/* Open Graph */}
  <meta property="og:title" content={metaTitle} />

  {metaDescription && (
    <meta property="og:description" content={metaDescription} />
  )}

  <meta
    property="og:image"
    content="https://planjourneysglobal.com/assets/img/site-logo.PNG"
  />

  <meta property="og:type" content="website" />

  {/* Twitter */}
  <meta name="twitter:title" content={metaTitle} />

  {metaDescription && (
    <meta name="twitter:description" content={metaDescription} />
  )}

  <meta
    name="twitter:image"
    content="https://planjourneysglobal.com/assets/img/site-logo.PNG"
  />

  <meta name="twitter:card" content="summary_large_image" />
</Helmet>
<div className="headerhoem">
 <Header/>
 </div>
<>

{/* home3 Banner Section Start */}
<div className="home3-banner-section">
  <div className="swiper home2-banner-slider">
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1}
      loop={true}
      autoplay={
        showStatic
          ? false
          : { delay: 5000, disableOnInteraction: false }
      }
      pagination={{
        el: ".banner-pagination",
        clickable: true,
      }}
      observer={true}
      observeParents={true}
      key={showStatic ? "static" : "dynamic"} // 🔥 force re-init
    >

      {/* STATIC SLIDE */}
      {showStatic && (
        <SwiperSlide>
          <div className="banner-wrapper static">
            <div className="banner-video-area">
              <BannerMedia
                video="/assets/img/home2/banner-img1.jpg"
                image="/assets/img/home2/banner-img1.jpg"   fetchPriority={'high'}
  loading={'eager'}
              />
            </div>

            {/* <div className="banner-content-wrap">
              <div className="container">
                <div className="banner-content">
                  <div className="award-rating-area">
                    <h4>Luxury Travel, Tailored for You</h4>
                  </div>
                  <h1>
                    Explore the world with care, enriched by culture and confidence.
                  </h1>
                  <p>
                    Explore the world with care, enriched by culture and confidence.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </SwiperSlide>
      )}

      {/* DYNAMIC SLIDES */}
      {!showStatic &&
        homeBanner?.map((item, index) => (
          <SwiperSlide key={index}>
               <a href={item.link}>
            <div className="banner-wrapper dyn">
              <div className="banner-video-area">
                
             
                <BannerMedia
                  video={item.video_url}
                  image={item.image_url}
                  alt={item.banner_name}
                />
               
              </div>

              <div className="banner-content-wrap">
                <div className="container">
                  <div className="banner-content">
                    <div className="award-rating-area">
                      <h4>{item.banner_name}</h4>
                    </div>
                    <h1>{item.home_title}</h1>
                    <p>{item.meta_discription}</p>
                  </div>
                </div>
              </div>
            </div>
             </a>
          </SwiperSlide>
        ))}
    </Swiper>
  </div>

  <div className="banner-pagination paginations"></div>
</div>



  <div className="filter-wrapper mb-100 wow animate fadeInDown">
    <div className="container wpapinner">
      <ul className="filter-item-list">
        <li className={`single-item ${activeTab === 0 ? "active" : ""}`}
          onClick={() => setActiveTab(0)}>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0698 22.0465V23.1628C15.0698 23.3848 15.158 23.5978 15.315 23.7548C15.472 23.9118 15.6849 24 15.907 24C16.129 24 16.342 23.9118 16.499 23.7548C16.656 23.5978 16.7442 23.3848 16.7442 23.1628V22.0465C16.7442 21.8245 16.656 21.6115 16.499 21.4545C16.342 21.2975 16.129 21.2093 15.907 21.2093C15.6849 21.2093 15.472 21.2975 15.315 21.4545C15.158 21.6115 15.0698 21.8245 15.0698 22.0465ZM13.3953 0.837209V6.4186C13.3953 6.64065 13.4835 6.85359 13.6405 7.0106C13.7976 7.16761 14.0105 7.25581 14.2325 7.25581C14.4546 7.25581 14.6675 7.16761 14.8245 7.0106C14.9815 6.85359 15.0698 6.64065 15.0698 6.4186V0.837209C15.0698 0.615168 14.9815 0.40222 14.8245 0.245213C14.6675 0.0882058 14.4546 0 14.2325 0C14.0105 0 13.7976 0.0882058 13.6405 0.245213C13.4835 0.40222 13.3953 0.615168 13.3953 0.837209ZM7.2558 22.0465V23.1628C7.2558 23.3848 7.344 23.5978 7.50101 23.7548C7.65802 23.9118 7.87097 24 8.09301 24C8.31505 24 8.528 23.9118 8.685 23.7548C8.84201 23.5978 8.93022 23.3848 8.93022 23.1628V22.0465C8.93022 21.8245 8.84201 21.6115 8.685 21.4545C8.528 21.2975 8.31505 21.2093 8.09301 21.2093C7.87097 21.2093 7.65802 21.2975 7.50101 21.4545C7.344 21.6115 7.2558 21.8245 7.2558 22.0465ZM8.93022 0.837209V6.4186C8.93022 6.64065 9.01842 6.85359 9.17543 7.0106C9.33244 7.16761 9.54538 7.25581 9.76743 7.25581C9.98947 7.25581 10.2024 7.16761 10.3594 7.0106C10.5164 6.85359 10.6046 6.64065 10.6046 6.4186V0.837209C10.6046 0.615168 10.5164 0.40222 10.3594 0.245213C10.2024 0.0882058 9.98947 0 9.76743 0C9.54538 0 9.33244 0.0882058 9.17543 0.245213C9.01842 0.40222 8.93022 0.615168 8.93022 0.837209Z"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.65113 1.67442H15.3488C15.5709 1.67442 15.7838 1.58621 15.9408 1.42921C16.0978 1.2722 16.186 1.05925 16.186 0.837209C16.186 0.615168 16.0978 0.40222 15.9408 0.245213C15.7838 0.0882057 15.5709 0 15.3488 0H8.65113C8.42909 0 8.21615 0.0882057 8.05914 0.245213C7.90213 0.40222 7.81392 0.615168 7.81392 0.837209C7.81392 1.05925 7.90213 1.2722 8.05914 1.42921C8.21615 1.58621 8.42909 1.67442 8.65113 1.67442ZM19.5349 8.65116C19.5349 7.83701 19.2114 7.0562 18.6357 6.48051C18.06 5.90482 17.2792 5.5814 16.4651 5.5814H7.53486C6.7207 5.5814 5.93989 5.90482 5.3642 6.48051C4.78851 7.0562 4.46509 7.83701 4.46509 8.65116V19.814C4.46509 20.6281 4.78851 21.4089 5.3642 21.9846C5.93989 22.5603 6.7207 22.8837 7.53486 22.8837H16.4651C17.2792 22.8837 18.06 22.5603 18.6357 21.9846C19.2114 21.4089 19.5349 20.6281 19.5349 19.814V8.65116ZM11.1628 9.76744V18.6977C11.1628 18.9197 11.251 19.1327 11.408 19.2897C11.565 19.4467 11.7779 19.5349 12 19.5349C12.222 19.5349 12.435 19.4467 12.592 19.2897C12.749 19.1327 12.8372 18.9197 12.8372 18.6977V9.76744C12.8372 9.5454 12.749 9.33245 12.592 9.17545C12.435 9.01844 12.222 8.93023 12 8.93023C11.7779 8.93023 11.565 9.01844 11.408 9.17545C11.251 9.33245 11.1628 9.5454 11.1628 9.76744ZM7.81392 9.76744V18.6977C7.81392 18.9197 7.90213 19.1327 8.05914 19.2897C8.21615 19.4467 8.42909 19.5349 8.65113 19.5349C8.87318 19.5349 9.08612 19.4467 9.24313 19.2897C9.40014 19.1327 9.48834 18.9197 9.48834 18.6977V9.76744C9.48834 9.5454 9.40014 9.33245 9.24313 9.17545C9.08612 9.01844 8.87318 8.93023 8.65113 8.93023C8.42909 8.93023 8.21615 9.01844 8.05914 9.17545C7.90213 9.33245 7.81392 9.5454 7.81392 9.76744ZM14.5116 9.76744V18.6977C14.5116 18.9197 14.5998 19.1327 14.7568 19.2897C14.9138 19.4467 15.1268 19.5349 15.3488 19.5349C15.5709 19.5349 15.7838 19.4467 15.9408 19.2897C16.0978 19.1327 16.186 18.9197 16.186 18.6977V9.76744C16.186 9.5454 16.0978 9.33245 15.9408 9.17545C15.7838 9.01844 15.5709 8.93023 15.3488 8.93023C15.1268 8.93023 14.9138 9.01844 14.7568 9.17545C14.5998 9.33245 14.5116 9.5454 14.5116 9.76744Z"
              />
            </g>
          </svg>
          <span>Tours</span>
        </li>
        <li className={`single-item ${activeTab === 1 ? "active" : ""}`}
          onClick={() => setActiveTab(1)}>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path d="M16.9221 1.23284C16.9197 1.03856 16.8717 0.847553 16.782 0.675228C16.6922 0.502902 16.5632 0.354077 16.4054 0.240751C16.244 0.122177 16.0563 0.0444497 15.8583 0.0142152C15.6604 -0.0160194 15.458 0.0021383 15.2686 0.0671357L7.1955 2.88632H16.9221V1.23284ZM12.375 15.0808C12.5734 15.0808 13.1232 14.0887 13.2018 12.1872H11.5483C11.6268 14.0887 12.1766 15.0808 12.375 15.0808ZM12.375 8.46682C12.1766 8.46682 11.6268 9.45891 11.5483 11.3604H13.2018C13.1232 9.45891 12.5734 8.46682 12.375 8.46682ZM11.2341 14.8741C10.909 14.0149 10.7355 13.1057 10.7215 12.1872H9.097C9.17316 12.7877 9.41272 13.3559 9.78957 13.8297C10.1664 14.3035 10.6661 14.6647 11.2341 14.8741ZM11.2341 8.67351C10.6661 8.88285 10.1664 9.24411 9.78957 9.7179C9.41272 10.1917 9.17316 10.7598 9.097 11.3604H10.7215C10.7355 10.4419 10.909 9.53271 11.2341 8.67351Z" />
              <path d="M4.52094 4.95319V23.1415C4.52094 23.4704 4.65159 23.7858 4.88416 24.0184C5.11672 24.2509 5.43215 24.3816 5.76105 24.3816H18.9889C19.3178 24.3816 19.6332 24.2509 19.8658 24.0184C20.0984 23.7858 20.229 23.4704 20.229 23.1415V4.95319C20.229 4.62429 20.0984 4.30886 19.8658 4.07629C19.6332 3.84373 19.3178 3.71307 18.9889 3.71307H5.76105C5.43215 3.71307 5.11672 3.84373 4.88416 4.07629C4.65159 4.30886 4.52094 4.62429 4.52094 4.95319ZM15.6819 20.4546H9.06801C8.95838 20.4546 8.85324 20.411 8.77571 20.3335C8.69819 20.256 8.65464 20.1508 8.65464 20.0412C8.65464 19.9316 8.69819 19.8264 8.77571 19.7489C8.85324 19.6714 8.95838 19.6278 9.06801 19.6278H15.6819C15.7916 19.6278 15.8967 19.6714 15.9742 19.7489C16.0518 19.8264 16.0953 19.9316 16.0953 20.0412C16.0953 20.1508 16.0518 20.256 15.9742 20.3335C15.8967 20.411 15.7916 20.4546 15.6819 20.4546ZM10.3081 18.8011C10.3081 18.6915 10.3517 18.5863 10.4292 18.5088C10.5067 18.4313 10.6119 18.3877 10.7215 18.3877H14.0285C14.1381 18.3877 14.2432 18.4313 14.3208 18.5088C14.3983 18.5863 14.4418 18.6915 14.4418 18.8011C14.4418 18.9107 14.3983 19.0159 14.3208 19.0934C14.2432 19.1709 14.1381 19.2145 14.0285 19.2145H10.7215C10.6119 19.2145 10.5067 19.1709 10.4292 19.0934C10.3517 19.0159 10.3081 18.9107 10.3081 18.8011ZM12.375 7.64009C13.1925 7.64009 13.9918 7.88253 14.6715 8.33675C15.3513 8.79097 15.8811 9.43656 16.194 10.1919C16.5069 10.9472 16.5888 11.7784 16.4293 12.5802C16.2698 13.3821 15.8761 14.1187 15.2979 14.6968C14.7198 15.2749 13.9833 15.6686 13.1814 15.8281C12.3796 15.9876 11.5484 15.9057 10.7931 15.5928C10.0377 15.28 9.39214 14.7501 8.93792 14.0704C8.48371 13.3906 8.24127 12.5914 8.24127 11.7738C8.24127 10.6775 8.67678 9.62605 9.452 8.85083C10.2272 8.07561 11.2786 7.64009 12.375 7.64009Z" />
              <path d="M15.653 11.3604C15.5768 10.7599 15.3373 10.1917 14.9604 9.71792C14.5836 9.24412 14.0839 8.88287 13.5159 8.67352C13.841 9.53272 14.0145 10.4419 14.0284 11.3604H15.653ZM15.653 12.1872H14.0284C14.0145 13.1057 13.841 14.0149 13.5159 14.8741C14.0839 14.6647 14.5836 14.3035 14.9604 13.8297C15.3373 13.3559 15.5768 12.7877 15.653 12.1872Z" />
            </g>
          </svg>
          <span>Visa</span>
        </li>
        <li  className={`single-item ${activeTab === 2 ? "active" : ""}`}
          onClick={() => setActiveTab(2)}>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C3.765 22 2 20.235 2 12C2 3.765 3.765 2 12 2C20.235 2 22 3.765 22 12C22 20.235 20.235 22 12 22ZM14.8135 7.43172C14.7403 7.29853 14.632 7.1879 14.5005 7.11182C14.3689 7.03573 14.219 6.99709 14.067 7.00007C13.9151 7.00305 13.7668 7.04754 13.6383 7.12873C13.5098 7.20992 13.406 7.3247 13.338 7.46066L9.88156 14.3736L8.35523 11.5984C8.28333 11.4677 8.17763 11.3586 8.04919 11.2827C7.92074 11.2067 7.77426 11.1667 7.62504 11.1667H6.16672C5.70648 11.1667 5.3334 11.5398 5.3334 12C5.3334 12.4602 5.70648 12.8333 6.16672 12.8333H7.13234L9.18656 16.5682C9.25981 16.7014 9.36809 16.812 9.49967 16.8881C9.63125 16.9642 9.78113 17.0028 9.93309 16.9998C10.085 16.9969 10.2333 16.9524 10.3618 16.8712C10.4903 16.7901 10.5941 16.6753 10.6621 16.5393L14.1186 9.62645L15.6449 12.4016C15.7168 12.5324 15.8225 12.6414 15.9509 12.7174C16.0793 12.7933 16.2258 12.8334 16.375 12.8334H17.8334C18.2936 12.8334 18.6667 12.4603 18.6667 12C18.6667 11.5398 18.2936 11.1667 17.8334 11.1667H16.8678L14.8135 7.43172Z"
            />
          </svg>
          <span>Experience</span>
        </li>
         <li  className={`single-item ${activeTab === 3 ? "active" : ""}`}
          onClick={() => setActiveTab(3)}>
          <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C3.765 22 2 20.235 2 12C2 3.765 3.765 2 12 2C20.235 2 22 3.765 22 12C22 20.235 20.235 22 12 22ZM14.8135 7.43172C14.7403 7.29853 14.632 7.1879 14.5005 7.11182C14.3689 7.03573 14.219 6.99709 14.067 7.00007C13.9151 7.00305 13.7668 7.04754 13.6383 7.12873C13.5098 7.20992 13.406 7.3247 13.338 7.46066L9.88156 14.3736L8.35523 11.5984C8.28333 11.4677 8.17763 11.3586 8.04919 11.2827C7.92074 11.2067 7.77426 11.1667 7.62504 11.1667H6.16672C5.70648 11.1667 5.3334 11.5398 5.3334 12C5.3334 12.4602 5.70648 12.8333 6.16672 12.8333H7.13234L9.18656 16.5682C9.25981 16.7014 9.36809 16.812 9.49967 16.8881C9.63125 16.9642 9.78113 17.0028 9.93309 16.9998C10.085 16.9969 10.2333 16.9524 10.3618 16.8712C10.4903 16.7901 10.5941 16.6753 10.6621 16.5393L14.1186 9.62645L15.6449 12.4016C15.7168 12.5324 15.8225 12.6414 15.9509 12.7174C16.0793 12.7933 16.2258 12.8334 16.375 12.8334H17.8334C18.2936 12.8334 18.6667 12.4603 18.6667 12C18.6667 11.5398 18.2936 11.1667 17.8334 11.1667H16.8678L14.8135 7.43172Z"
            />
          </svg>
          <span>Cruise</span>
        </li>
      </ul>
      <div className="filter-input-wrap">
        {activeTab === 0 && (
         <Tour></Tour>
        )}
        {activeTab === 1 && (
       <Visas></Visas>
         )}
         {activeTab === 2 && (
       <Exp></Exp>
        )}
         {activeTab === 3 && (
       <Cruie></Cruie>
        )}
        {/* <p>
          Can’t find what you’re looking for? create your{" "}
          <a href="/contact">Custom Itinerary</a>
        </p> */}
      </div>
    </div>
  </div>
  {/* home3 Banner Section End*/}
  {/* home3 offer and service Section Start*/}

 
  {/* home3 offer and service Section End*/}
  {/* home3 travel package Section Start*/}
  <div className="home3-travel-package-section mb-100 pt-3">
    <div className="container">
      <div
        className="row justify-content-center mb-0 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
             <div dangerouslySetInnerHTML={{ __html: homeData.popular_packages }}></div>
             
            {/* <p>
             {homeData.tab_title}
            </p> */}
          </div>
        </div>
      </div>
      <div className="rows gy-lg-5 gy-4">
         <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={15}
       navigation={true}
      slidesPerView={4}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
    >
      {packages.length > 0 ? (
        packages.map((item, index) => (
          <SwiperSlide key={index}>
          <div
            className="col-lg-12 col-md-12 wow animate fadeInDown"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
            <div className="package-card">
              <div className="package-img-wrap">
               <Link  to={`/tour-package/${item.slug}`} className="package-img">
                  <img
                    src={`https://planjourneysglobal.com/admin/${item.image}`}
                    alt={item.title}
                      fetchPriority={'high'}
  loading={'eager'}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/img/no-image.png";
                    }}
                  />
                </Link >

                {item.is_hot_sale === 1 && (
                  <div className="batch">
                    <span>Hot Sale!</span>
                  </div>
                )}
              </div>

              <div className="package-content">
                <h5>
                  <Link  to={`/tour-package/${item.slug}`}>
                    {item.title}
                  </Link >
                </h5>

                <div className="location-and-time">
                  <div className="location">
                   <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.83615 0C3.77766 0 1.28891 2.48879 1.28891 5.54892C1.28891 7.93837 4.6241 11.8351 6.05811 13.3994C6.25669 13.6175 6.54154 13.7411 6.83615 13.7411C7.13076 13.7411 7.41561 13.6175 7.6142 13.3994C9.04821 11.8351 12.3834 7.93833 12.3834 5.54892C12.3834 2.48879 9.89464 0 6.83615 0ZM7.31469 13.1243C7.18936 13.2594 7.02008 13.3342 6.83615 13.3342C6.65222 13.3342 6.48295 13.2594 6.35761 13.1243C4.95614 11.5959 1.69584 7.79515 1.69584 5.54896C1.69584 2.7134 4.00067 0.406933 6.83615 0.406933C9.67164 0.406933 11.9765 2.7134 11.9765 5.54896C11.9765 7.79515 8.71617 11.5959 7.31469 13.1243Z"></path>
                                        <path d="M6.83618 8.54554C8.4624 8.54554 9.7807 7.22723 9.7807 5.60102C9.7807 3.9748 8.4624 2.65649 6.83618 2.65649C5.20997 2.65649 3.89166 3.9748 3.89166 5.60102C3.89166 7.22723 5.20997 8.54554 6.83618 8.54554Z"></path>
                                    </svg>
                    <span>{item.location}</span>
                  </div>

                <svg class="arrow" width="25" height="6" viewBox="0 0 25 6" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 3L5 5.88675V0.113249L0 3ZM25 3L20 0.113249V5.88675L25 3ZM4.5 3.5H20.5V2.5H4.5V3.5Z"></path>
                                </svg>

                  <span>{item.duration}</span>
                </div>

                <div className="btn-and-price-area">
                  <Link  to={`/tour-package/${item.slug}`} className="primary-btn1">
                    <span>View More</span>
                    <span>View More</span>
                  </Link >

                  <div className="price-area">
                      <span>{getPrice(item)}</span> / <h6>Person</h6>
                  </div>
                </div>

                <svg className="divider" height={6} viewBox="0 0 374 6">
                  <path d="M5 2.5L0 0.113249V5.88675L5 3.5V2.5ZM369 3.5L374 5.88675V0.113249L369 2.5V3.5ZM4.5 3.5H369.5V2.5H4.5V3.5Z" />
                </svg>

                <div className="bottom-area">
                  <ul>
                    <li><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.2732 12.9807H6.7268C6.68429 12.9807 6.64298 12.9666 6.60935 12.9406C6.55906 12.9018 5.36398 11.9718 4.14989 10.4857C3.43499 9.61078 2.86499 8.72565 2.45543 7.8549C1.93974 6.75846 1.67834 5.68141 1.67834 4.65329C1.67834 3.50657 2.36043 2.33394 3.54995 1.43595C4.1378 0.992226 4.81163 0.641781 5.55321 0.394396C6.33797 0.132617 7.16112 0 8 0C8.83888 0 9.66203 0.132617 10.4466 0.394396C11.1882 0.641781 11.862 0.992035 12.4499 1.43595C13.6392 2.33394 14.3215 3.50676 14.3215 4.65329C14.3215 5.63247 14.0599 6.67939 13.544 7.7647C13.1348 8.62565 12.5652 9.51367 11.8511 10.4036C10.6383 11.9148 9.40697 12.9272 9.39468 12.9371C9.36046 12.9653 9.31752 12.9807 9.2732 12.9807ZM6.79378 12.5969H9.20334C9.4465 12.3905 10.5082 11.4651 11.5563 10.1576C12.6425 8.8026 13.9374 6.74772 13.9374 4.65329C13.9374 2.63794 11.3981 0.38384 7.99981 0.38384C4.60148 0.38384 2.06238 2.63794 2.06238 4.65329C2.06238 6.85769 3.3563 8.90624 4.44199 10.2364C5.49084 11.5215 6.55311 12.4032 6.79378 12.5969Z"></path>
                                            <path d="M7.51886 12.7888C7.51886 12.7888 5.68372 9.03538 5.68372 4.65327C5.68372 2.43045 6.72066 0.191895 8 0.191895C9.27934 0.191895 10.3163 2.43045 10.3163 4.65327C10.3163 8.82024 8.48114 12.7888 8.48114 12.7888"></path>
                                            <path d="M7.34653 12.873C7.32753 12.8343 6.87594 11.9042 6.41802 10.4209C5.9956 9.05229 5.492 6.94079 5.492 4.65329C5.492 3.53843 5.74668 2.39036 6.19079 1.50312C6.67577 0.533921 7.31832 0 8.00002 0C8.68172 0 9.32426 0.53373 9.80944 1.50312C10.2535 2.39036 10.5082 3.53843 10.5082 4.65329C10.5082 6.82928 10.0048 8.94655 9.5824 10.3393C9.12505 11.8478 8.67423 12.8283 8.65542 12.8692L8.30709 12.7082C8.31169 12.6984 8.7675 11.7058 9.21717 10.2213C9.63114 8.85481 10.1246 6.77977 10.1246 4.65329C10.1246 3.5962 9.88467 2.51051 9.46648 1.67489C9.05577 0.854428 8.52146 0.38384 8.00021 0.38384C7.47895 0.38384 6.94465 0.854428 6.53394 1.67489C6.11574 2.51051 5.87584 3.5962 5.87584 4.65329C5.87584 6.893 6.37023 8.96439 6.78497 10.3076C7.23406 11.7626 7.68699 12.6951 7.6916 12.7043L7.34653 12.873ZM8.77038 16H7.22965C6.84658 16 6.5349 15.6883 6.5349 15.3052V13.9892C6.5349 13.8833 6.62088 13.7973 6.72682 13.7973H9.27321C9.37915 13.7973 9.46513 13.8833 9.46513 13.9892V15.3052C9.46513 15.6883 9.15346 16 8.77038 16ZM6.91874 14.1812V15.3052C6.91874 15.4766 7.05826 15.6162 7.22965 15.6162H8.77038C8.94177 15.6162 9.08129 15.4766 9.08129 15.3052V14.1812H6.91874Z"></path>
                                            <path d="M8.90952 14.1812H7.0907C7.00606 14.1812 6.93159 14.126 6.90703 14.045L6.54334 12.8445C6.52568 12.7863 6.53662 12.7232 6.5729 12.6745C6.60917 12.6257 6.66636 12.5969 6.72701 12.5969H9.2734C9.33424 12.5969 9.39143 12.6257 9.42751 12.6745C9.4454 12.6985 9.45739 12.7264 9.46252 12.756C9.46765 12.7855 9.46579 12.8158 9.45707 12.8445L9.09338 14.045C9.06862 14.1258 8.99397 14.1812 8.90952 14.1812ZM7.23291 13.7974H8.76693L9.01431 12.9808H6.98552L7.23291 13.7974Z"></path>
                                        </svg>Experience</li>
                    <li><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z"></path>
                                                <path d="M11.0984 7.32445H8.6197V4.84576C8.6197 4.5037 8.3427 4.22607 8.00001 4.22607C7.65733 4.22607 7.38033 4.5037 7.38033 4.84576V7.32445H4.90164C4.55895 7.32445 4.28195 7.60207 4.28195 7.94414C4.28195 8.2862 4.55895 8.56382 4.90164 8.56382H7.38033V11.0425C7.38033 11.3846 7.65733 11.6622 8.00001 11.6622C8.3427 11.6622 8.6197 11.3846 8.6197 11.0425V8.56382H11.0984C11.4411 8.56382 11.7181 8.2862 11.7181 7.94414C11.7181 7.60207 11.4411 7.32445 11.0984 7.32445Z"></path>
                                            </g>
                                        </svg>Inclusion<div class="info">
                                            <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path d="M6 0.375C4.88748 0.375 3.79995 0.704901 2.87492 1.32298C1.94989 1.94107 1.22892 2.81957 0.80318 3.84741C0.377437 4.87524 0.266043 6.00624 0.483085 7.09738C0.700127 8.18853 1.23586 9.19081 2.02253 9.97748C2.8092 10.7641 3.81148 11.2999 4.90262 11.5169C5.99376 11.734 7.12476 11.6226 8.1526 11.1968C9.18043 10.7711 10.0589 10.0501 10.677 9.12508C11.2951 8.20006 11.625 7.11252 11.625 6C11.6245 4.50831 11.0317 3.07786 9.97693 2.02307C8.92215 0.968289 7.49169 0.375497 6 0.375ZM6 9.375C5.85167 9.375 5.70666 9.33101 5.58333 9.2486C5.45999 9.16619 5.36386 9.04906 5.30709 8.91201C5.25033 8.77497 5.23548 8.62417 5.26441 8.47868C5.29335 8.3332 5.36478 8.19956 5.46967 8.09467C5.57456 7.98978 5.7082 7.91835 5.85369 7.88941C5.99917 7.86047 6.14997 7.87533 6.28702 7.93209C6.42406 7.98886 6.54119 8.08499 6.62361 8.20832C6.70602 8.33166 6.75 8.47666 6.75 8.625C6.74941 8.82373 6.6702 9.01415 6.52968 9.15468C6.38915 9.2952 6.19873 9.37441 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.5944 6.71834 6.52472 6.85999 6.41224 6.9632C6.29976 7.0664 6.15266 7.12367 6 7.12367C5.84735 7.12367 5.70024 7.0664 5.58776 6.9632C5.47528 6.85999 5.40561 6.71834 5.3925 6.56625L5.14125 3.55875C5.13042 3.44226 5.1434 3.32478 5.1794 3.21346C5.2154 3.10214 5.27367 2.99931 5.35067 2.91123C5.42767 2.82314 5.52178 2.75165 5.62729 2.70108C5.73279 2.65052 5.84748 2.62195 5.96437 2.61711C6.08127 2.61227 6.19793 2.63126 6.30725 2.67294C6.41657 2.71461 6.51627 2.77808 6.60029 2.8595C6.6843 2.94092 6.75087 3.03858 6.79595 3.14655C6.84103 3.25451 6.86367 3.37051 6.8625 3.4875C6.86313 3.51131 6.86187 3.53514 6.85875 3.55875Z"></path>
                                                </g>
                                            </svg>
                                            <div class="tooltip-text">This package covers <span>Accommodation, Daily Meals, Entry Fees &amp; Local Transfers</span> to ensure a worry-free trip.</div>
                                        </div></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </SwiperSlide>
        ))
      ) : (
        <p>Loading...</p>
      )}
       </Swiper>
      </div>
       <div class="row gy-lg-5 gy-4 mt-4 cmnbt">
   <div class="col-lg-12 d-flex justify-content-center mt-2 text-center">
        <div dangerouslySetInnerHTML={{ __html: homeData.popular_activies_bottom }}></div>
       </div>
       </div>
    <div className="row gy-lg-5 gy-4 mt-2">

      <div class="col-lg-12 d-flex justify-content-center mt-2">
                    <a href="/package" class="primary-btn1 transparent">
                        <span>
                            View All 
                            <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                            </svg>
                        </span>
                        <span>
                            View All
                            <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path>
                            </svg>
                        </span>
                    </a>
                </div>
                </div>
    </div>

  </div>
  {/* home3 travel package Section End*/}


  

  {/* home3 travel package Section Start*/}
  <div className="home3-travel-package-section mb-100 bgpopular_activies" style={{
  backgroundColor: '#e9e9e9 ',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  minHeight: '666px'
}}>
    <div className="container">
  
      <div className="row gy-lg-5 gy-4 blockflex">
       <div className="col-xl-12 col-lg-12">
          <div className="section-title text-center">
         <div dangerouslySetInnerHTML={{ __html: homeData.popular_activies }}></div>
          </div>
        </div>

          <div 
            className="col-lg-12 col-md-12 wow animate fadeInDown"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
         <Swiper
   modules={[Navigation, Pagination, Autoplay]}
       spaceBetween={15}
      slidesPerView={4}
      pagination={{ clickable: true }}
       navigation={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
    >  
            {popularactivities.length > 0 ? (
        popularactivities.map((item, index) => (
       <SwiperSlide key={index}>
            <div className="package-card" >
              <div className="package-img-wrap">
               <Link  to={`/activity/${item.slug}`} className="package-img">
                  <img
                    fetchPriority={'high'}
  loading={'eager'}
                    src={`https://planjourneysglobal.com/admin/${item.image}`}
                    alt={item.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/img/no-image.png";
                    }}
                  />
                </Link >

                {item.is_hot_sale === 1 && (
                  <div className="batch">
                    <span>Hot Sale!</span>
                  </div>
                )}
              </div>

              <div className="package-content">
                <h5>
                  <Link  to={`/activity/${item.slug}`}>
                    {item.title}
                  </Link >
                </h5>


                <div className="btn-and-price-area">
                  <Link  to={`/activity/${item.slug}`} className="primary-btn1">
                    <span>View More</span>
                    <span>View More</span>
                  </Link >

                  <div className="price-area">
                      <span>{getPrice(item)}</span> / <h6>Person</h6>
                  </div>
                </div>

                <svg className="divider" height={6} viewBox="0 0 374 6">
                  <path d="M5 2.5L0 0.113249V5.88675L5 3.5V2.5ZM369 3.5L374 5.88675V0.113249L369 2.5V3.5ZM4.5 3.5H369.5V2.5H4.5V3.5Z" />
                </svg>

                <div className="bottom-area">
                  <ul>
                    <li><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.2732 12.9807H6.7268C6.68429 12.9807 6.64298 12.9666 6.60935 12.9406C6.55906 12.9018 5.36398 11.9718 4.14989 10.4857C3.43499 9.61078 2.86499 8.72565 2.45543 7.8549C1.93974 6.75846 1.67834 5.68141 1.67834 4.65329C1.67834 3.50657 2.36043 2.33394 3.54995 1.43595C4.1378 0.992226 4.81163 0.641781 5.55321 0.394396C6.33797 0.132617 7.16112 0 8 0C8.83888 0 9.66203 0.132617 10.4466 0.394396C11.1882 0.641781 11.862 0.992035 12.4499 1.43595C13.6392 2.33394 14.3215 3.50676 14.3215 4.65329C14.3215 5.63247 14.0599 6.67939 13.544 7.7647C13.1348 8.62565 12.5652 9.51367 11.8511 10.4036C10.6383 11.9148 9.40697 12.9272 9.39468 12.9371C9.36046 12.9653 9.31752 12.9807 9.2732 12.9807ZM6.79378 12.5969H9.20334C9.4465 12.3905 10.5082 11.4651 11.5563 10.1576C12.6425 8.8026 13.9374 6.74772 13.9374 4.65329C13.9374 2.63794 11.3981 0.38384 7.99981 0.38384C4.60148 0.38384 2.06238 2.63794 2.06238 4.65329C2.06238 6.85769 3.3563 8.90624 4.44199 10.2364C5.49084 11.5215 6.55311 12.4032 6.79378 12.5969Z"></path>
                                            <path d="M7.51886 12.7888C7.51886 12.7888 5.68372 9.03538 5.68372 4.65327C5.68372 2.43045 6.72066 0.191895 8 0.191895C9.27934 0.191895 10.3163 2.43045 10.3163 4.65327C10.3163 8.82024 8.48114 12.7888 8.48114 12.7888"></path>
                                            <path d="M7.34653 12.873C7.32753 12.8343 6.87594 11.9042 6.41802 10.4209C5.9956 9.05229 5.492 6.94079 5.492 4.65329C5.492 3.53843 5.74668 2.39036 6.19079 1.50312C6.67577 0.533921 7.31832 0 8.00002 0C8.68172 0 9.32426 0.53373 9.80944 1.50312C10.2535 2.39036 10.5082 3.53843 10.5082 4.65329C10.5082 6.82928 10.0048 8.94655 9.5824 10.3393C9.12505 11.8478 8.67423 12.8283 8.65542 12.8692L8.30709 12.7082C8.31169 12.6984 8.7675 11.7058 9.21717 10.2213C9.63114 8.85481 10.1246 6.77977 10.1246 4.65329C10.1246 3.5962 9.88467 2.51051 9.46648 1.67489C9.05577 0.854428 8.52146 0.38384 8.00021 0.38384C7.47895 0.38384 6.94465 0.854428 6.53394 1.67489C6.11574 2.51051 5.87584 3.5962 5.87584 4.65329C5.87584 6.893 6.37023 8.96439 6.78497 10.3076C7.23406 11.7626 7.68699 12.6951 7.6916 12.7043L7.34653 12.873ZM8.77038 16H7.22965C6.84658 16 6.5349 15.6883 6.5349 15.3052V13.9892C6.5349 13.8833 6.62088 13.7973 6.72682 13.7973H9.27321C9.37915 13.7973 9.46513 13.8833 9.46513 13.9892V15.3052C9.46513 15.6883 9.15346 16 8.77038 16ZM6.91874 14.1812V15.3052C6.91874 15.4766 7.05826 15.6162 7.22965 15.6162H8.77038C8.94177 15.6162 9.08129 15.4766 9.08129 15.3052V14.1812H6.91874Z"></path>
                                            <path d="M8.90952 14.1812H7.0907C7.00606 14.1812 6.93159 14.126 6.90703 14.045L6.54334 12.8445C6.52568 12.7863 6.53662 12.7232 6.5729 12.6745C6.60917 12.6257 6.66636 12.5969 6.72701 12.5969H9.2734C9.33424 12.5969 9.39143 12.6257 9.42751 12.6745C9.4454 12.6985 9.45739 12.7264 9.46252 12.756C9.46765 12.7855 9.46579 12.8158 9.45707 12.8445L9.09338 14.045C9.06862 14.1258 8.99397 14.1812 8.90952 14.1812ZM7.23291 13.7974H8.76693L9.01431 12.9808H6.98552L7.23291 13.7974Z"></path>
                                        </svg>Experience</li>
                    <li><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4108 16 8C16 3.58916 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.728 1.23934 8C1.23934 4.27203 4.27266 1.23934 8 1.23934C11.7273 1.23934 14.7607 4.27203 14.7607 8C14.7607 11.728 11.728 14.7607 8 14.7607Z"></path>
                                                <path d="M11.0984 7.32445H8.6197V4.84576C8.6197 4.5037 8.3427 4.22607 8.00001 4.22607C7.65733 4.22607 7.38033 4.5037 7.38033 4.84576V7.32445H4.90164C4.55895 7.32445 4.28195 7.60207 4.28195 7.94414C4.28195 8.2862 4.55895 8.56382 4.90164 8.56382H7.38033V11.0425C7.38033 11.3846 7.65733 11.6622 8.00001 11.6622C8.3427 11.6622 8.6197 11.3846 8.6197 11.0425V8.56382H11.0984C11.4411 8.56382 11.7181 8.2862 11.7181 7.94414C11.7181 7.60207 11.4411 7.32445 11.0984 7.32445Z"></path>
                                            </g>
                                        </svg>Inclusion<div class="info">
                                            <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path d="M6 0.375C4.88748 0.375 3.79995 0.704901 2.87492 1.32298C1.94989 1.94107 1.22892 2.81957 0.80318 3.84741C0.377437 4.87524 0.266043 6.00624 0.483085 7.09738C0.700127 8.18853 1.23586 9.19081 2.02253 9.97748C2.8092 10.7641 3.81148 11.2999 4.90262 11.5169C5.99376 11.734 7.12476 11.6226 8.1526 11.1968C9.18043 10.7711 10.0589 10.0501 10.677 9.12508C11.2951 8.20006 11.625 7.11252 11.625 6C11.6245 4.50831 11.0317 3.07786 9.97693 2.02307C8.92215 0.968289 7.49169 0.375497 6 0.375ZM6 9.375C5.85167 9.375 5.70666 9.33101 5.58333 9.2486C5.45999 9.16619 5.36386 9.04906 5.30709 8.91201C5.25033 8.77497 5.23548 8.62417 5.26441 8.47868C5.29335 8.3332 5.36478 8.19956 5.46967 8.09467C5.57456 7.98978 5.7082 7.91835 5.85369 7.88941C5.99917 7.86047 6.14997 7.87533 6.28702 7.93209C6.42406 7.98886 6.54119 8.08499 6.62361 8.20832C6.70602 8.33166 6.75 8.47666 6.75 8.625C6.74941 8.82373 6.6702 9.01415 6.52968 9.15468C6.38915 9.2952 6.19873 9.37441 6 9.375ZM6.85875 3.55875L6.6075 6.56625C6.5944 6.71834 6.52472 6.85999 6.41224 6.9632C6.29976 7.0664 6.15266 7.12367 6 7.12367C5.84735 7.12367 5.70024 7.0664 5.58776 6.9632C5.47528 6.85999 5.40561 6.71834 5.3925 6.56625L5.14125 3.55875C5.13042 3.44226 5.1434 3.32478 5.1794 3.21346C5.2154 3.10214 5.27367 2.99931 5.35067 2.91123C5.42767 2.82314 5.52178 2.75165 5.62729 2.70108C5.73279 2.65052 5.84748 2.62195 5.96437 2.61711C6.08127 2.61227 6.19793 2.63126 6.30725 2.67294C6.41657 2.71461 6.51627 2.77808 6.60029 2.8595C6.6843 2.94092 6.75087 3.03858 6.79595 3.14655C6.84103 3.25451 6.86367 3.37051 6.8625 3.4875C6.86313 3.51131 6.86187 3.53514 6.85875 3.55875Z"></path>
                                                </g>
                                            </svg>
                                            <div class="tooltip-text">This package covers <span>Accommodation, Daily Meals, Entry Fees &amp; Local Transfers</span> to ensure a worry-free trip.</div>
                                        </div></li>
                  </ul>
                </div>
              </div>
              
            </div>
            </SwiperSlide>
             
            ))
      ) : (
        <p>Loading...</p>
      )}  
     </Swiper> 
          </div>
           <div class="row gy-lg-5 gy-4 mt-4 cmnbt">
   <div class="col-lg-12 d-flex justify-content-center mt-2 text-center">
        <div dangerouslySetInnerHTML={{ __html: homeData.popular_activies_bottom }}></div>
       </div>
       </div>
 <div class="row gy-lg-5 gy-4 mt-2">
 
 <div class="col-lg-12 d-flex justify-content-center  mt-2"><a href="/activity" class="primary-btn1 transparent"><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span></a>
 </div>
 </div>

      </div>
    </div>
 
  </div>
  {/* home3 travel package Section End*/}



    {/* home3 travel package Section Start*/}
  <div className="home3-travel-package-section mb-100 visas">
    <div className="container">
  
      <div className="row gy-lg-5 gy-4 blockflex">
     
       <div className="col-xl-12 col-lg-12">
          <div className="section-title text-center">
     <div dangerouslySetInnerHTML={{ __html: homeData.popular_visa }}></div>
          </div>
        </div>
          
          <div 
            className="col-lg-12 col-md-12 wow animate fadeInDown"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
      <Swiper
   modules={[Navigation, Pagination, Autoplay]}
       spaceBetween={15}
      slidesPerView={5}
      pagination={{ clickable: true }}
       navigation={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 5, // Desktop
          },
        }}
    > 
            {popularvisa.length > 0 ? (
        popularvisa.map((item, index) => (
         <SwiperSlide>
            <div className="package-card" key={index}>
              <div className="package-img-wrap">
               <Link  to={`/visa/${item.slug}`} className="package-img">
                  <img
                    fetchPriority={'high'}
  loading={'eager'}
                    src={`${item.image}`}
                    alt={item.country_name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/img/no-image.png";
                    }}
                  />
                </Link >

               
              </div>

              <div className="package-content">
                <h5>
                  <Link  to={`/visa/${item.slug}`}>
                    {item.country_name}
                  </Link >
                </h5>
              </div>
              
            </div>
            </SwiperSlide>
              
            ))
      ) : (
        <p></p>
      )}  
    </Swiper>
          </div>
           <div class="row gy-lg-5 gy-4 mt-2 cmnbt">
   <div class="col-lg-12 d-flex justify-content-center mt-2 text-center">
        <div dangerouslySetInnerHTML={{ __html: homeData.popular_visa_bottom }}></div>
       </div>
       </div>
       <div class="row gy-lg-5 gy-4 mt-2">
       <div class="col-lg-12 d-flex justify-content-center mt-2"><a href="/visa" class="primary-btn1 transparent"><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span></a>
       </div>
       </div>


         
       
    
 
      </div>
    </div>
 
  </div>
  {/* home3 travel package Section End*/}

 {/* home3 destination Section Start*/}
 <div className="home3-destination-section mb-0" style={{
  backgroundImage: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.3) 100%), url('assets/img/home1/home1-offer-banner-bg.jpg')",
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed'
}}>
    <div className="container">
       {/* <div
        className="row justify-content-center mb-10 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-lg-8">
          <div className="section-title text-center">
            <span>Best Agency Ever!  </span>
           
          </div>
        </div>
      </div> */}
            <div className="feature-and-rating-area mb-0 wow animate fadeInDown"
      data-wow-delay="500ms"
      data-wow-duration="3000ms">
        <div className="row g-4">

           {homeData?.top_destinations?.map((item, index) => (
          <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
            <div className="single-feature">
              <div className="icon">
                <img
                  src={item.image_url} alt={item.paragraph}   fetchPriority={'high'}
  loading={'eager'} />
              </div>
              <h5>{item.paragraph}</h5>
            </div>
          </div>
         ))}
        </div>
    
      </div>
  
    </div>
  </div>


 <div className="home3-destination-section mb-100">
    <div className="container">
     
      <div
        className="row justify-content-center mb-10 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-lg-8">
          <div className="section-title text-center">
            <h2>{homeData.top_destination_heading}</h2>
            <p> {homeData.top_destination_description}
             
            </p>
          </div>
        </div>
      </div>

      <div className="destination-slider-area">
        <div className="swiper home3-destination-slider">
         <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={5}
      spaceBetween={10}
      navigation={true}
      pagination={{ clickable: true }}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
               pauseOnMouseEnter: true, // 👈 ADD THIS
            }}
      loop={true}
       breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 5, // Desktop
          },
        }}
      
       className="swiper-wrapper"
    >

       {destination.map((item, index) => (
            <SwiperSlide className="swiper-slide">
              <div className="destination-card2 two">
                <div className="destination-img">
                   <img
                     fetchPriority={'high'}
  loading={'eager'}
    src={`https://planjourneysglobal.com/admin/${item.image}`}
    alt={item.name}
    onError={(e) => {
      e.target.onerror = null;
      e.target.src = "/assets/img/no-image.png";
    }}
  />
                  <Link to={`/destination/${item.slug}`} className="arrow">
                    <svg
                      width={14}
                      height={14}
                      viewBox="0 0 14 14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 13C5.94664 8.05336 13 1 13 1M13 1C10.1852 1.52778 6.69444 2.58333 3 1M13 1C12.4722 3.63889 11.4167 6.77778 13 11"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Link>
                </div>
                <div className="destination-content">
                  <h5>
                   <Link to={`/destination/${item.slug}`} className="arrow">{item.name}</Link>
                  </h5>
               
                </div>
              </div>
            </SwiperSlide>
          
          ))}  
        
         </Swiper>
        </div>
  
      </div>
    </div>
  </div>

  {/* home3 destination Section End*/}
 
  {/* home3 offer and service Section Start*/}

  {adverteseBanner?.length > 0 && (
  <div className="home3-offer-and-service-section mb-100 wow animate fadeIn" >
    <div className="container">
      <div className="offer-area">
        <div className="row g-4">
           {adverteseBanner.map((item, index) => (
          <div
            className="col-lg-6 wow animate fadeInLeft"
            data-wow-delay="500ms"
            data-wow-duration="3000ms" key={index}
          >
            <a href={item.link}>
              <img src={item.banner1} alt={item.banner1}   fetchPriority={'high'}
  loading={'eager'} />
            </a>
          </div>
                 ))}
        </div>
      </div>
      <div
        className="service-wrapper three wow animate fadeInUp d-none"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="section-title">
          <h2 className="test">{homeData.tab_title}</h2>
                    <a href={homeData.tab_link}>
            View All Package
            <svg
              width={10}
              height={10}
              viewBox="0 0 10 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </a>
        </div>
        <ul className="service-list wow animate fadeInUp">
        {homeData?.desire_places?.map((item, index) => (
          <li className="single-service" key={index}>
          <div className="icon">
            <img src={item.image_url} alt={item.heading} width={20} height={20}   fetchPriority={'high'}
  loading={'eager'} />
          </div> 
            <div className="content">
            <h3>{item.heading}</h3>
            <p>{item.description}</p>
            </div>
          </li>
          ))}
      </ul>


      </div>
    </div>
  </div>
  )}
  {/* home3 offer and service Section End*/}
 
  {/* home3 about Section Start*/}

  <div className="home3-about-section d-none">
    <div className="container">
      <div className="about-wrapper">
        <div className="row align-items-center justify-content-between">
          <div
            className="col-xl-6 col-lg-7 wow animate fadeInLeft d-none"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
            <div className="about-content">
              <div className="section-title">
                    <div className="text" dangerouslySetInnerHTML={{ __html: homeData.top_agency }}></div>
                <a href={homeData.top_agency_link}>
                  About More
                  <svg
                    width={10}
                    height={10}
                    viewBox="0 0 10 10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </a>
              </div>
          
            </div>
          </div>
          <div
            className="col-lg-12 d-lg-block d-none wow animate fadeInRight"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
            <div className="about-img">
              <img src={homeData.top_agency_image_url} alt=""   fetchPriority={'high'}
  loading={'eager'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* home3 about Section End*/}

     {/* home3 travel package Section Start*/}
  <div className="home3-travel-package-section mb-100 home3-destination-section blogs" style={{
  backgroundColor: '#285340',
    background: '#285340',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat', 
  backgroundAttachment: 'fixed',
  minHeight: '666px'
}}>
    <div className="container">
  
      <div className="row gy-lg-5 gy-4 blockflex">
 
<div className="col-xl-12 col-lg-12">
          <div className="section-title text-center">
              <div dangerouslySetInnerHTML={{ __html: homeData.popular_blogs }}></div>
          </div>
        </div>
         
          <div 
            className="col-lg-12 col-md-12 wow animate fadeInDown"
            data-wow-delay="500ms"
            data-wow-duration="3000ms"
          >
             <Swiper
   modules={[Navigation, Pagination, Autoplay]}
       spaceBetween={15}
      slidesPerView={4}
      pagination={{ clickable: true }}
       navigation={true}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
         pauseOnMouseEnter: true, // 👈 ADD THIS
      }}
      loop={true}
         breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
             className="swiper-wrapper"

    >
            {popularblogs.length > 0 ? (
        popularblogs.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="package-card" >
              <div className="package-img-wrap">
               <Link  to={`/blog/${item.slug}`} className="package-img">
                  <img src={item.home_image_url} alt={item.blog_name}    fetchPriority={'high'}
  loading={'eager'}/>
                </Link >

              
              </div>

              <div className="package-content">
                <h5>
                  <Link  to={`/blog/${item.slug}`}>
                    {item.blog_name}
                  </Link >
                </h5>

              </div>
              
            </div>
              </SwiperSlide>
            ))
      ) : (
        <p>Loading...</p>
      )}  
    </Swiper>
          </div>
           <div class="row gy-lg-5 gy-4 mt-4 cmnbt">
   <div class="col-lg-12 d-flex justify-content-center mt-2 text-center">
        <div dangerouslySetInnerHTML={{ __html: homeData.popular_blogs_bottom }}></div>
       </div>
       </div>
       <div class="row gy-lg-5 gy-4 mt-2">
       <div class="col-lg-12 d-flex justify-content-center mt-2">
       <a href="/blog" class="primary-btn1 transparent"><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span><span>View All<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M9.73535 1.14746C9.57033 1.97255 9.32924 3.26406 9.24902 4.66797C9.16817 6.08312 9.25559 7.5453 9.70214 8.73633C9.84754 9.12406 9.65129 9.55659 9.26367 9.70215C8.9001 9.83849 8.4969 9.67455 8.32812 9.33398L8.29785 9.26367L8.19921 8.98438C7.73487 7.5758 7.67054 5.98959 7.75097 4.58203C7.77875 4.09598 7.82525 3.62422 7.87988 3.17969L1.53027 9.53027C1.23738 9.82317 0.762615 9.82317 0.469722 9.53027C0.176829 9.23738 0.176829 8.76262 0.469722 8.46973L6.83593 2.10254C6.3319 2.16472 5.79596 2.21841 5.25 2.24902C3.8302 2.32862 2.2474 2.26906 0.958003 1.79102L0.704097 1.68945L0.635738 1.65527C0.303274 1.47099 0.157578 1.06102 0.310542 0.704102C0.463655 0.347333 0.860941 0.170391 1.22363 0.28418L1.29589 0.310547L1.48828 0.387695C2.47399 0.751207 3.79966 0.827571 5.16601 0.750977C6.60111 0.670504 7.97842 0.428235 8.86132 0.262695L9.95312 0.0585938L9.73535 1.14746Z"></path></svg></span></a>
       </div>
       </div>
 
      </div>
    </div>
   
  </div>
  {/* home3 travel package Section End*/}
  {/* home3 Counter Section Start*/}

   {/* home3 pramotion Section Start*/}
{Pramotionpackeg && Pramotionpackeg.length > 0 && (
  <div className="home3-travel-package-section mb-100">
    <div className="container">
      <div
        className="row justify-content-center mb-20 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
         {hasPosterHeading ? (
  <div
    className="poster-heading"
    dangerouslySetInnerHTML={{
      __html: homeData.poster_heading_editor,
    }}
  />
) : (
  <div className="poster-heading">
    <h2>Hurry! Exclusive Offers Inside</h2>
  </div>
)}

          </div>
        </div>
      </div>
   <div className="col-xl-12 col-lg-12">
      <div className="rowa gy-lg-5 gy-4  wow animate fadeInDown" >
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={4}
          spaceBetween={20}
          navigation={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true, // 👈 ADD THIS
            }}
          loop={true}
           breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
          className="swiper-wrapper"
        >
          {Pramotionpackeg.map((item, index) => (
            <SwiperSlide className="swiper-slide itemoffer" key={index}>
              <a href={item.link}>
                <img className="radius-box"
                  fetchPriority={'high'}
  loading={'eager'}
                  src={item.poster}
                  alt={item.poster}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/assets/img/no-image.png";
                  }}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      </div>
    </div>
  </div>
)}
  {/* home3 tour guide Section End*/}
<>
  {/* home1 testimonial Section Start*/}

 {testimonial?.length > 0 && (
  <div className="home1-testimonial-section mb-100">
    <div className="container">
      <div
        className="row justify-content-center mb-10 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            {hasDynamicTestimonial ? (
  <div
    className="testimonial-section"
    dangerouslySetInnerHTML={{
      __html: homeData.testimonial_section,
    }}
  />
) : (
  <div className="testimonial-section">
    <h2>Client Testimonials</h2>
    <p>They planned our trip beautifully.</p>
  </div>
)}

          </div> 
        </div>
      </div>

      <div className="row mb-0">
        <div className="col-lg-12">
          <div className="swiper home1-testimonial-slider">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={4}
              spaceBetween={10}
              navigation={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                 pauseOnMouseEnter: true, // 👈 ADD THIS
              }}
                loop={true}
           breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
              
              className="swiper-wrapper"
            >
              {testimonial.map((item, index) => (
                <SwiperSlide className="swiper-slide" key={index}>
                  <div className="testimonial-card">
                    <div className="author-area">
                      <div className="author-img">
                        <img
                          fetchPriority={'high'}
  loading={'eager'}
                          src={item.image_url}
                          alt={item.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/img/no-image.png";
                          }}
                        />
                      </div>
                      <div className="author-info">
                        <h5>{item.name}</h5>
                        <span>{item.specialization}</span>
                      </div>
                    </div>

                    <h5>{item.title}</h5>
                    <div className="content">
                      <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
)}


  {/* home1 testimonial Section End*/}
</>

  {/* pramotion Section End*/}

  <div className="counter-section three mb-100">
    <div className="container">
      <div className="counter-wrapper  wow animate fadeInDown">
        <div className="row gy-md-5 gy-4">
           {homeData?.best_agencies?.map((item, index) => (
          <div className="col-lg-3 col-sm-6 divider">
            <div className="single-counter">
              <div className="icon">
             <img src={item.image_url} width={40} height={40} alt={item.heading}   fetchPriority={'high'}
  loading={'eager'} />
              </div>
              <div className="content">
                <div className="number">
                  <h2 className="counter">{item.heading}</h2>
                </div>
                <span>{item.paragraph}</span>
              </div>
            </div>
          </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* home3 Counter Section End*/}

  {/* home3 tour guide Section Start*/}
 



{tourGuide?.length > 0 && (
  <div className="home3-tour-guide-section mb-100">
    <div className="container">
      <div
        className="row justify-content-center mb-50 wow animate fadeInDown"
        data-wow-delay="500ms"
        data-wow-duration="3000ms"
      >
        <div className="col-xl-6 col-lg-8">
          <div className="section-title text-center">
            <h2>Tour Guided</h2>
            <p>
              A curated list of the most popular travel packages based on
              different destinations.
            </p>
          </div>
        </div>
      </div>

      <div className="team-slider-area mb-60">
        <div className="swiper home3-guide-slider">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={4}
            spaceBetween={10}
            navigation={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
             breakpoints={{
          0: {
            slidesPerView: 1, // Mobile
          },
          640: {
            slidesPerView: 2, // Tablet
          },
          1024: {
            slidesPerView: 4, // Desktop
          },
        }}
            className="swiper-wrapper"
          >
            {tourGuide.map((item, index) => (
              <SwiperSlide className="swiper-slide" key={index}>
                <div className="tour-guide-card">
                  <div className="guide-img-wrap">
                    <div className="guide-img">
                      <img
                        fetchPriority={'high'}
  loading={'eager'}
                        src={item.image_url}
                        alt={item.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/assets/img/no-image.png";
                        }}
                      />
                    </div>
                  </div>
                  <div className="guide-info">
                    <h5>{item.name}</h5>
                    <span>{item.specialization}</span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  </div>
)}

 


 
</>


  <Footer />
</>

    )
}
export default Home;